import React from "react";
import { motion } from "framer-motion";
import { trackLead } from "../../lib/track";

const TELEGRAM_URL = "https://t.me/+cr1LhxIMB-5jODJl";

const FinalCTA = () => {
  return (
    <section id="contact" className="relative py-32 md:py-48 overflow-hidden">
      {/* Ambient background */}
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[1100px] w-[1100px] rounded-full bg-[radial-gradient(circle,rgba(78,168,255,0.18),transparent_60%)] blur-3xl" />
        <div className="absolute left-1/2 -translate-x-1/2 bottom-[-30%] h-[120%] w-[160%] rounded-full border border-[#4ea8ff]/15" />
        <div className="absolute left-1/2 -translate-x-1/2 bottom-[-20%] h-[100%] w-[130%] rounded-full border border-[#4ea8ff]/10" />
        <div className="absolute inset-0 opacity-[0.05] [background-image:linear-gradient(rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.5)_1px,transparent_1px)] [background-size:90px_90px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,black,transparent_70%)]" />
      </div>

      <div className="relative mx-auto max-w-[1100px] px-6 md:px-10 text-center">
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.03] px-4 py-1.5 text-[11px] tracking-[0.28em] uppercase text-white/70 backdrop-blur-md"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-[#4ea8ff] shadow-[0_0_10px_#4ea8ff] anim-pulse-soft" />
          The Edge is Open
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.1, ease: [0.2, 0.7, 0.2, 1] }}
          className="mt-8 font-display text-[48px] sm:text-[72px] md:text-[104px] lg:text-[120px] leading-[0.95] tracking-[-0.04em] text-balance"
        >
          <span className="text-gradient-silver">Trade smarter</span>{" "}
          <span className="text-gradient-blue">with BIGBULL.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="mt-8 mx-auto max-w-[560px] text-[16px] md:text-[18px] text-white/55 font-light"
        >
          Join the room. Receive the binary signals. Trade Quotex with structure.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.4 }}
          className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackLead("final_telegram")}
            className="btn-pill btn-primary-blue text-[13px] px-7 py-4"
            data-testid="final-cta"
          >
            Join Telegram
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 2L11 13" />
              <path d="M22 2L15 22L11 13L2 9L22 2Z" />
            </svg>
          </a>
          <span className="text-[11px] tracking-[0.28em] uppercase text-white/40">
            Free Access · No card needed
          </span>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
